import {Store} from "vuex";
import {ObjectRepository} from "@api/repositories/ObjectRepository";
import {EventMembershipRepository} from "@api/repositories/EventMembershipRepository";
import {SessionRepository} from "@api/repositories/SessionRepository";
import {EventMembership} from "@api/models/EventMemberShip";
import Vue from "vue";
import {RatingRepository} from "@api/repositories/RatingRepository";
import {ArrayHelpers} from "@common/ArrayHelpers";
import {CommentsService} from "@share/program/data/CommentsService";
import {Rating} from "@api/models/Rating";
import {WebinarInfo} from "@api/models/WebinarInfo";

export class AgendaInfoService {
    private readonly _agendaSchema: string;

    constructor(
        private readonly store: Store<any>,
        private readonly objectRepository: ObjectRepository,
        private readonly eventMembershipRepository: EventMembershipRepository,
        private readonly sessionRepository: SessionRepository,
        private readonly ratingRepository: RatingRepository,
        private readonly commentsService: CommentsService
    ) {
        this._agendaSchema = process.env.VUE_APP_AGENDA_SCHEMA as string;
    }

    public async fetchSpeakers(ids: string[] = []): Promise<Record<string, EventMembership[]>> {
        try {
            return ids.length ? await this.eventMembershipRepository.speakers(this._agendaSchema, ids) : {};
        }
        catch (e) {
            this.store.dispatch('reportException', e, { root: true });
        }
        return {};
    }

    public async fetchWebinarsInfo(ids: string[]): Promise<{ [key: string]: WebinarInfo }> {
        let result = {};
        if (ids.length) {
            try {
                result = await this.sessionRepository.webinar(this._agendaSchema, ids);
            } catch (e) {
                this.store.dispatch('reportException', e, { root: true });
            }

        }
        return result;
    }

    public async fetchLikes(ids: string[]): Promise<Record<string, Rating>> {
        const result = {};
        if (ids.length) {
            try {
                const likes = await this.ratingRepository.query(this._agendaSchema, ids);
                return ArrayHelpers.keyBy(likes, 'objectId');
            } catch (e) {
                this.store.dispatch('reportException', e, { root: true });
            }
        }
        return result;
    }

    public async fetchCommentsCount(ids: string[]) {
        return await this.commentsService.fetchCount(ids, this._agendaSchema);
    }

    public async fetchAdditionalData(ids: string[]) {
        const [webinarInfos, likes, comments] = await Promise.all([
            this.fetchWebinarsInfo(ids),
            this.fetchLikes(ids),
            this.fetchCommentsCount(ids),
        ]);

        return {
            webinarInfos,
            likes,
            comments
        }
    }
}